import type { TFunction } from 'i18next'

import { values } from 'lodash/fp'

import { PricingEngineType } from '@/shared/generated'

export const getPricingCampaignEngines = (t: TFunction) =>
	values(PricingEngineType).map((engine) => ({
		label: t(engine, { defaultValue: engine }),
		value: engine,
	}))

export const getAnchoringBehaviorChoices = (t: TFunction) => [
	{
		label: t('behavior.highlight', { defaultValue: 'Just highlight' }),
		value: 'highlight',
	},
	{
		label: t('behavior.correct', { defaultValue: 'Correct to boundary' }),
		value: 'correct',
	},
]
export const getAnchoringTypeChoices = (t: TFunction) => [
	{
		label: t('anchoring.flat_anchor', { defaultValue: 'Flat anchor' }),
		value: 'flat_anchor',
		variant: 'info',
	},
	{
		label: t('anchoring.sized_anchor', { defaultValue: 'Sized anchor' }),
		value: 'sized_anchor',
		variant: 'destructive',
	},
	{
		label: t('anchoring.product_set', { defaultValue: 'Product set' }),
		value: 'product_set',
		variant: 'warning',
	},
	{
		label: t('anchoring.ladder_anchor', { defaultValue: 'Ladder' }),
		value: 'ladder_anchor',
		variant: 'success',
	},
	{
		label: t('anchoring.bundle_anchor', { defaultValue: 'Bundle' }),
		value: 'bundle_anchor',
		variant: 'epic',
	},
]
